<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6">
          <v-card
            color="blue"
            max-height="150px"
            class="card-background"
            @click="$router.push({ name: 'hotels' })"
          >
            <v-img
              src="../assets/img/hotel.jpg"
              gradient="to top, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="150px"
            >
              <v-card-title>
                <v-icon class="mx-auto" color="white" x-large>mdi-bed</v-icon>
              </v-card-title>
              <v-card-text class="text-center">
                <span class="display-1 white--text">Hotels</span>
              </v-card-text>
            </v-img>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6">
          <v-card
            color="blue"
            max-height="150px"
            class="card-background"
            @click="$router.push({ name: 'tripsTours' })"
          >
            <v-img
              src="../assets/img/trip.jpg"
              gradient="to top, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="150px"
            >
              <v-card-title>
                <v-icon class="mx-auto" color="white" x-large>mdi-beach</v-icon>
              </v-card-title>
              <v-card-text class="text-center">
                <span class="display-1 white--text">Packages</span>
              </v-card-text>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
